import {GalleryType} from "../../offer/components/quick_view/QWImageWithButton";
import {hitGoogleTagManager} from "./init_google_tag_manager";

enum SidebarQuickViewGTMEvent {
    MAP_SIDEBAR_QUICK_VIEW = "invest_map_events"
}

enum SidebarQuickViewAction {
    MAP_SIDEBAR_QUICK_VIEW_ACTION = "sidebar"
}

enum SidebarQuickViewLabel {
    MAP_SIDEBAR_QUICK_VIEW_PROPERTY = "property",
    MAP_SIDEBAR_QUICK_VIEW_PHOTO = "photo",
    MAP_SIDEBAR_QUICK_VIEW_PLAN = "rzut"
}

export const gtmClickPropertyMoreInfo = () => {
    const eventData = {
        event: SidebarQuickViewGTMEvent.MAP_SIDEBAR_QUICK_VIEW,
        action: SidebarQuickViewAction.MAP_SIDEBAR_QUICK_VIEW_ACTION,
        label: SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PROPERTY
    };

    hitGoogleTagManager(eventData);
};

export const gtmClickGalleryButton = (type: GalleryType) => {
    const label = type === "photo" ? SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PHOTO : SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PLAN;

    const eventData = {
        event: SidebarQuickViewGTMEvent.MAP_SIDEBAR_QUICK_VIEW,
        action: SidebarQuickViewAction.MAP_SIDEBAR_QUICK_VIEW_ACTION,
        label
    };

    hitGoogleTagManager(eventData);
};
import {GalleryType} from "../../offer/components/quick_view/QWImageWithButton";
import {hitGoogleTagManager} from "./init_google_tag_manager";

enum SidebarQuickViewGTMEvent {
    MAP_SIDEBAR_QUICK_VIEW = "invest_map_events"
}

enum SidebarQuickViewAction {
    MAP_SIDEBAR_QUICK_VIEW_ACTION = "sidebar"
}

enum SidebarQuickViewLabel {
    MAP_SIDEBAR_QUICK_VIEW_PROPERTY = "property",
    MAP_SIDEBAR_QUICK_VIEW_PHOTO = "photo",
    MAP_SIDEBAR_QUICK_VIEW_PLAN = "rzut"
}

export const gtmClickPropertyMoreInfo = () => {
    const eventData = {
        event: SidebarQuickViewGTMEvent.MAP_SIDEBAR_QUICK_VIEW,
        action: SidebarQuickViewAction.MAP_SIDEBAR_QUICK_VIEW_ACTION,
        label: SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PROPERTY
    };

    hitGoogleTagManager(eventData);
};

export const gtmClickGalleryButton = (type: GalleryType) => {
    const label = type === "photo" ? SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PHOTO : SidebarQuickViewLabel.MAP_SIDEBAR_QUICK_VIEW_PLAN;

    const eventData = {
        event: SidebarQuickViewGTMEvent.MAP_SIDEBAR_QUICK_VIEW,
        action: SidebarQuickViewAction.MAP_SIDEBAR_QUICK_VIEW_ACTION,
        label
    };

    hitGoogleTagManager(eventData);
};
